import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { GetAdminV1StoresStoreIdReportsProductsEngagementSort } from '@nucleus-commerce/api-client/admin';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

/** The endpoint's cap: the top 100 products, `truncated` when more had activity. */
export const PRODUCT_ENGAGEMENT_LIMIT = 100;

export const DEFAULT_ENGAGEMENT_SORT: GetAdminV1StoresStoreIdReportsProductsEngagementSort =
  '-views';

export function productEngagementReportQueryOptions(
  storeId: string,
  { from, to }: DayRange,
  sort: GetAdminV1StoresStoreIdReportsProductsEngagementSort = DEFAULT_ENGAGEMENT_SORT,
) {
  return queryOptions({
    queryKey: reportKeys.productEngagement(storeId, { from, to }, sort),
    queryFn: () =>
      reportsApi.productEngagement(storeId, { from, to }, sort, PRODUCT_ENGAGEMENT_LIMIT),
    placeholderData: keepPreviousData,
  });
}

export function useProductEngagementReport(
  storeId: string,
  range: DayRange,
  sort: GetAdminV1StoresStoreIdReportsProductsEngagementSort = DEFAULT_ENGAGEMENT_SORT,
) {
  return useQuery(productEngagementReportQueryOptions(storeId, range, sort));
}
